import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import cn from 'classnames'

import { CustomButton, Icon } from 'src/components/ui'

import styles from './InputPromo.module.scss'

interface Props {
  className?: string
}

const InputPromoPage: React.FC<Props> = ({ className }) => {
  const [inputValue, setInputValue] = React.useState<string>('')
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className={cn(styles.container, className)}>
      <h1>{t('promo_code.input_promo_below')}</h1>

      <div className={styles.container_input}>
        <label htmlFor='promo'>{t('promo_code.promo')}</label>
        <div>
          <input
            type='text'
            id='promo'
            placeholder={t('promo_code.input_promo')}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
          {inputValue.length > 0 && (
            <button className={styles.clear} onClick={() => setInputValue('')}>
              <Icon name='delete' />
            </button>
          )}
        </div>
      </div>

      <CustomButton
        className={styles.container_button}
        variant={inputValue.length > 0 ? 'contained' : 'not-active'}
        color='violet'
        onClick={() => navigate('/promo-error')}
      >
        {t('promo_code.recieve')}
      </CustomButton>
    </div>
  )
}

export default InputPromoPage
